import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';

import { About } from '../About/About';
import { HeaderDrawerContent } from './HeaderDrawerContent';

interface HeaderDrawerProps {
    translations: Record<string, string>;
}

export const HeaderDrawer: React.FC<HeaderDrawerProps> = ({ translations }) => {
    const [open, setOpen] = useState(false);
    const [showAbout, setShowAbout] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleAbout = () => {
        toggleDrawer();
        setShowAbout(true);
    };

    return (
        <>
            {showAbout && <About translations={translations} onClose={() => setShowAbout(false)} />}
            <IconButton edge="start" color="inherit" size="large" aria-label="menu" onClick={toggleDrawer}>
                <MenuIcon />
            </IconButton>
            <Drawer anchor="left" open={open} onClose={toggleDrawer}>
                <HeaderDrawerContent translations={translations} onClose={toggleDrawer} onAbout={handleAbout} />
            </Drawer>
        </>
    );
};
